import React, { useContext } from 'react';
import { FactContext } from '../context/FactContext';

const Wallet = () => {
    const { currentAccount } = useContext(FactContext);
    const status = {
        NO_WALLET: "no_wallet",
        WALLET_CONNECTED: "wallet_connected",
    }

    const buildUIForState = state => {
        if(state == status.NO_WALLET) {
            return (
                <div></div>
            );
        } else if(state == status.WALLET_CONNECTED) {
            return (
                <div className='wallet-button'>
                    {`${currentAccount.substring(0, 10)}`}
                </div>
            )
        } else {
            return (
                <p>{'Something went wrong!'}</p>
            )
        }
    }

    const getState = () => {
        if(!currentAccount) {
            return status.NO_WALLET;
        } else if(currentAccount) {
            return status.WALLET_CONNECTED;
        } else {
            return status.ERROR;
        }
    }

    return (
        <div>
            {buildUIForState(getState())}
        </div>
    )
}

export default Wallet;